// extracted by mini-css-extract-plugin
module.exports = {"header":"VZetGY8dxHXB-DOL6hmnfQ==","avatar":"SWoJA0cJsepoRVc9HU7Kgw==","title":"+brUr03ma-UOOYZN-P0IIg==","value":"xZNuWJV64mm1aixAmHoKSg==","closeIcon":"A96xrVe298N43f6addd7PA=="};